"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemOrdersRules = void 0;
const react_1 = __importStar(require("react"));
const Sentry = __importStar(require("@sentry/react"));
const react_bootstrap_1 = require("react-bootstrap");
const client_1 = require("@apollo/client");
const Offcanvas = __importStar(require("../../../general/Offcanvas"));
const LoadingSpinner_1 = __importDefault(require("../../../general/LoadingSpinner"));
const AccountContext_1 = require("../../../../contexts/AccountContext");
const useToast_1 = __importDefault(require("../../../general/Toast/useToast"));
const Toast_1 = __importDefault(require("../../../general/Toast/Toast"));
const SettingSwitch_1 = require("./SettingSwitch");
const rulesReducer_1 = require("./rulesReducer");
const graphql_1 = require("./graphql");
const styles_1 = require("./styles");
const ProblemOrdersRules = ({ onHide, show }) => {
    const { account } = (0, AccountContext_1.useAccount)();
    const [error, setError] = (0, react_1.useState)(null);
    const [updating, setUpdating] = (0, react_1.useState)(false);
    const { data: rulesData, loading, refetch: refetchRules } = (0, client_1.useQuery)(graphql_1.GET_RULES_QUERY, {
        variables: account ? { accountId: account.id } : undefined,
        // don't run query until this component is shown
        skip: !show,
        onError: (err) => {
            Sentry.captureException(err);
            setError(err.message);
        }
    });
    const { setToastMessage, toastParams } = (0, useToast_1.default)();
    const [updateRule] = (0, client_1.useMutation)(graphql_1.UPDATE_RULE_MUTATION);
    const [rulesObject, dispatch] = (0, react_1.useReducer)(rulesReducer_1.rulesReducer, null);
    // set rules object to a more manageable and easily searchable structure that
    // we can modify when the form values change
    (0, react_1.useEffect)(() => {
        if (rulesData === null || rulesData === void 0 ? void 0 : rulesData.rules) {
            dispatch({ type: 'SET_RULES', payload: rulesData });
        }
    }, [rulesData === null || rulesData === void 0 ? void 0 : rulesData.rules]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (updating || !rulesObject || !account) {
            return;
        }
        setError(null);
        setUpdating(true);
        const updates = Object.entries(rulesObject).map(([_key, rule]) => {
            return updateRule({
                variables: {
                    input: {
                        id: rule.id,
                        enabled: rule.enabled,
                        variables: JSON.stringify(rule.variables),
                        accountId: account.id
                    }
                }
            });
        });
        Promise.all(updates)
            .then(() => __awaiter(void 0, void 0, void 0, function* () {
            yield refetchRules();
            setToastMessage('Rules updated!');
        }))
            .catch((err) => {
            Sentry.captureException(err);
            setError(err.message);
        })
            .finally(() => {
            setUpdating(false);
        });
    };
    const lastScannedIntervalHours = () => {
        const value = rulesObject === null || rulesObject === void 0 ? void 0 : rulesObject.ShipmentLastUpdateReceived.variables.lastScannedIntervalHours;
        if (value === undefined) {
            return '48';
        }
        return value.toString();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
        react_1.default.createElement(Offcanvas.Container, { onHide: onHide, placement: 'end', show: show, style: { maxWidth: '17.5rem' } },
            react_1.default.createElement(Offcanvas.Header, null,
                react_1.default.createElement(Offcanvas.Title, null, "Problem Orders"),
                react_1.default.createElement(Offcanvas.CloseButton, { onClick: onHide })),
            react_1.default.createElement(Offcanvas.Body, null,
                error && (react_1.default.createElement(styles_1.ErrorContainer, null,
                    react_1.default.createElement("i", { className: 'fe fe-alert-octagon' }),
                    react_1.default.createElement("p", null, "Sorry, an error has occured. Our team has been notified. Please refresh the page and try again."))),
                (!error && loading) || !rulesObject ? (react_1.default.createElement(styles_1.LoadingSpinnerContainer, null,
                    react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: handleSubmit },
                    react_1.default.createElement(styles_1.FormBodyContainer, null,
                        react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'delivery-failed', label: 'Delivery Failed', onChange: (value) => dispatch({
                                type: 'DELIVERY_ATTEMPTED_ENABLED',
                                payload: value
                            }), value: rulesObject.ShipmentDeliveryAttempted.enabled }),
                        react_1.default.createElement(styles_1.Description, null, "Send an event to your integrated apps if a carrier status is: Delivery failed"),
                        react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'return-to-sender', label: 'Return to sender', onChange: (value) => dispatch({
                                type: 'RETURN_TO_SENDER_ENABLED',
                                payload: value
                            }), value: rulesObject.ShipmentReturnedToSender.enabled }),
                        react_1.default.createElement(styles_1.Description, null, "Send an event to your integrated apps if a carrier status is: Return to sender"),
                        react_1.default.createElement(SettingSwitch_1.SettingSwitch, { disabled: updating, id: 'stalled', label: 'Stalled', onChange: (value) => dispatch({
                                type: 'LAST_UPDATE_RECEIVED_ENABLED',
                                payload: value
                            }), value: rulesObject.ShipmentLastUpdateReceived.enabled }),
                        react_1.default.createElement(styles_1.Description, null, "Send an event to your integrated apps if a carrier status hasn\u2019t been updated in this many hours:"),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: 'stalled-last-updated' },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Status last updated 48 hrs ago"),
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { disabled: updating ||
                                    !rulesObject.ShipmentLastUpdateReceived.enabled, onChange: ({ target: { value } }) => {
                                    dispatch({
                                        type: 'LAST_UPDATE_RECEIVED_INTERVAL',
                                        payload: value
                                    });
                                }, value: lastScannedIntervalHours() }))),
                    react_1.default.createElement(react_bootstrap_1.Button, { disabled: updating, style: { margin: '1rem' }, type: 'submit', variant: 'malomo-primary' }, "Save")))))));
};
exports.ProblemOrdersRules = ProblemOrdersRules;
